import React, { useState } from "react";
import Slider from "./Slider"; // Supposons que Slider soit votre composant
import NB from "./NB";

const SimulateurCreditConso = ({ titre }) => {
  const [loanAmount, setLoanAmount] = useState(1000000); // Montant du crédit à la consommation
  const [annualInterestRate, setAnnualInterestRate] = useState(7); // Taux d'intérêt annuel
  const [loanTermMonths, setLoanTermMonths] = useState(1); // Durée du prêt en mois
  const [monthlyPayment, setMonthlyPayment] = useState(null); // Paiement mensuel calculé

  const calculateMonthlyPayment = () => {
    const P = loanAmount;
    const r = annualInterestRate / 100 / 12; // Convertir le taux annuel en taux mensuel et en décimal
    const n = loanTermMonths; // La durée est déjà en mois

    // Vérifier si l'une des entrées est nulle ou zéro, ce qui rendrait le calcul invalide
    if (!P || !r || !n) {
      setMonthlyPayment("Entrée invalide");
      return <div>Entrée invalide</div>;
    }

    const M = (P * (r * Math.pow(1 + r, n))) / (Math.pow(1 + r, n) - 1);

    setMonthlyPayment(isFinite(M) ? M : "Entrée invalide"); // Définir le paiement mensuel calculé
  };

  const isButtonDisabled =
    !loanAmount || !annualInterestRate || !loanTermMonths;

  return (
    <div className="simulator-container">
      <div className="simulateur-titre">{titre}</div>
      <div className="simulator">
        <div className="simulator-right">
          <Slider
            label="Montant du crédit:"
            unit="XOF"
            min={0}
            max={60000000}
            stepCount={2} // Ajuster pour un défilement plus fluide
            value={loanAmount}
            setValue={setLoanAmount}
          />

          <Slider
            label="Taux:"
            unit="%"
            min={7}
            max={15}
            stepCount={5} // Ajuster pour un défilement plus fluide
            value={annualInterestRate}
            setValue={setAnnualInterestRate}
          />
          <Slider
            label="Durée:"
            unit="mois"
            min={0}
            max={60}
            stepCount={4} // Ajuster pour un défilement plus fluide
            value={loanTermMonths}
            setValue={setLoanTermMonths}
          />
          <div className="btn-container">
            <button
              onClick={calculateMonthlyPayment}
              className="btn-full"
              disabled={isButtonDisabled}
            >
              Lancer la simulation
            </button>
          </div>

          <NB />
        </div>
        {monthlyPayment !== null && (
          <div className="simulator-left animate__animated animate__zoomInUp">
            <div className="result-row">
              <h3>Montant du crédit:</h3>{" "}
              <div className="result-row-variable">
                {loanAmount.toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
            <div className="result-row">
              <h3>Taux:</h3>{" "}
              <div className="result-row-variable">
                {annualInterestRate.toFixed(0)}%{" "}
              </div>
            </div>
            <div className="result-row">
              <h3>Durée:</h3>{" "}
              <div className="result-row-variable">
                {loanTermMonths.toFixed(0)} mois{" "}
              </div>
            </div>

            <div className="result-row">
              <h3>Paiement Mensuel:</h3>
              <div className="result-row-variable final-result">
                {Math.floor(monthlyPayment).toLocaleString("fr-FR")} XOF{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimulateurCreditConso;
